import React from "react";
import { Hidden } from "@material-ui/core";
import SectionMain from "../../components/SectionMain";
import RegisterUserPageDesktop from "./desktop";
import RegisterUserPageMobile from "./mobile";

const RegisterUserPage = () => {
  return (
    <SectionMain noPadding position="center">
      <Hidden only={["xs", "sm"]}>
        <RegisterUserPageDesktop />
      </Hidden>
      <Hidden only={["md", "lg", "xl"]}>
        <RegisterUserPageMobile />
      </Hidden>
    </SectionMain>
  );
};

export default RegisterUserPage;
